import React from 'react';
type SectionHeadingProps = {
  id: string;
  children: React.ReactNode;
  className?: string;
};
export function SectionHeading({
  id,
  children,
  className = ''
}: SectionHeadingProps) {
  return <div className={`text-center ${className}`} data-id="element-203" data-mp="vytka0m3k6hk">
      <h2 id={id} className="mx-auto max-w-3xl text-balance text-3xl font-bold leading-tight tracking-tight text-white sm:text-4xl" data-id="element-204" data-mp="vxjo5gyt18dk">
        {children}
      </h2>
    </div>;
}